module.exports = __webpack_public_path__ + "static/media/loading.897232c4.gif";